<div [kalLoading]="loading"
     [formGroup]="form">
    <kal-form-field>

        <kal-input formControlName="chequeNumber"
                   label="Numéro de chèque"></kal-input>

    </kal-form-field>

    <kal-form-field>

        <kal-select formControlName="bankName"
                    label="Banque"
                    placeholder="Sélectionner une banque">

            <kal-option *ngFor="let bank of banksList"
                        [value]="bank">
                {{ bank }}
            </kal-option>

        </kal-select>

    </kal-form-field>

    <kal-form-field>

        <kal-input formControlName="tireName"
                   label="Nom tiré"></kal-input>

    </kal-form-field>
</div>
